import React, { useEffect, useState } from "react";
import { setDoc, doc, getDoc, } from "firebase/firestore";
import styles from './ConfessionCard.module.css';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { auth, db } from "../../config/FirebaseConfig";
import useStore from "../../store"
import SmartText from "./SmartText"
import ShareCustom from "./ShareCustom"
import categoriesConst from "../constants/Constants"

var randomMC = require('random-material-color');


const MAX_TEXT_LENGTH_BEFORE_READ_MORE = 500




function ConfessionCard({text, date, name, displayIconRight, disLikedByIds, likedByIds, post_id, isLikeGroupDisabled, isAuth, categoryCode, numOfDislikes}) {

  const [likedBy, setLikedBy] = useState(likedByIds);
  const [disLikedBy, setDisLikedBy] = useState(disLikedByIds);

  const userData = useStore((state) => state.userData);

  const displayName = userData && userData.displayName || null
  const uid = userData && userData.uid || null
console.log("wiiii: ", disLikedBy)

  const likePost = async () => {

    const docRef = doc(db, 'posts', post_id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let likedbyNew = docSnap.data().likedBy || []
      await setDoc(doc(db, "posts", post_id), {
        likedBy: [...likedbyNew, uid],
        likedByCount: likedbyNew.length + 1
      }, { merge: true });
      setLikedBy([...likedbyNew, uid])
    } else {
      console.log("No document for count");
    }
  }

  const removeLike = async() => {
    
    const docRef = doc(db, 'posts', post_id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let data = docSnap.data()
      let likedbyNew = data.likedBy || []
      let likedByFiltered = likedbyNew.filter(post => post != uid);
      await setDoc(doc(db, "posts", post_id), {
        likedBy: [...likedByFiltered],
        likedByCount: likedByFiltered.length
      }, { merge: true });
      setLikedBy([...likedByFiltered])
    } else {
      console.log("No document for count");
    }
  }

  const dislikePost = async () => {
    // let docToDeleteRef = likesCollectionRef.where('post_id', '==', post_id).where('user_id', '==', auth.currentUser.uid);
    // docToDeleteRef.get().then((querySnapshot) => {
    //   querySnapshot.forEach((doc) => {
    //     doc.ref.delete();
    //   });
    // });

    const docRef = doc(db, 'posts', post_id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let disLikedbyNew = docSnap.data().disLikedBy || []
      await setDoc(doc(db, "posts", post_id), {
        disLikedBy: [...disLikedbyNew, uid],
        diLikedByCount: disLikedbyNew.length + 1
      }, { merge: true });
      setDisLikedBy([...disLikedbyNew, uid])
    } else {
      console.log("No document for count");
    }
  }

  const removeDisLike = async() => {
    
    const docRef = doc(db, 'posts', post_id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let data = docSnap.data()
      let disLikedbyNew = data.disLikedBy || []
      let disLikedByFiltered = disLikedbyNew.filter(post => post != uid);
      await setDoc(doc(db, "posts", post_id), {
        disLikedBy: [...disLikedByFiltered],
        disLikedByCount: disLikedByFiltered.length
      }, { merge: true });
      setDisLikedBy([...disLikedByFiltered])
    } else {
      console.log("No document for count");
    }
  }

  let generateColor = (text) => {
    return randomMC.getColor({ text: text });
  }

  return (
    <Box
      width='100%'
      className={styles.box}
      style={{overflow: "hidden", textOverflow: "ellipsis"}}
    >
      <Grid className={styles.cardHeader}>
        <Grid item xs={6}>
          <Stack direction="row" spacing={2}>
            <h3 className={styles.name}>{name || 'No name'}</h3>
            <p className={styles.date}> {date && new Date(date.seconds * 1000).toLocaleDateString("en-US") || '00:00'}</p>
            {categoriesConst.find(category => category.categoryCode === categoryCode) && 
              <Chip
                size="small"
                variant={"outlined"}
                label={categoriesConst.find(category => category.categoryCode === categoryCode).categoryValue  }
                style={{
                  borderColor: generateColor(categoriesConst.find(category => category.categoryCode === categoryCode).categoryValue) || '#000', 
                  //background: selectedCategory.categoryValue === category.categoryValue ? '#d9d9d9' : null
                }}
              />}
          </Stack>
        </Grid>
        
        {displayIconRight && 
          <Grid xs={6} justifyContent="flex-end" container>
            <IconButton style={{alignItems: "right"}}>
              {displayIconRight}
            </IconButton>
          </Grid>
        }
      </Grid>
      <Grid >
        <SmartText text={text} length={MAX_TEXT_LENGTH_BEFORE_READ_MORE} />
        <Grid sx={{mt:2}} container>
          <Grid itme xs={6}>
            <Stack direction="row" spacing={5}>
                <div>
                  {likedBy && likedBy.includes(uid) ?
                    <IconButton disabled={isLikeGroupDisabled || !isAuth} onClick={() => removeLike()} style={{alignItems: "right"}}>
                      <ThumbUpIcon color='error' className={styles.likeIcon}/>
                    </IconButton>
                    :
                    <IconButton disabled={isLikeGroupDisabled || !isAuth} onClick={() => likePost()} style={{alignItems: "right"}}>
                      <ThumbUpIcon className={styles.likeIcon}/>
                    </IconButton>
                  }
                  <p className={styles.numOfLikes}>{likedBy && likedBy.length ? likedBy.length : 0}</p>
                </div>
                <div>
                  {disLikedBy && disLikedBy.includes(uid) ?
                    <IconButton disabled={isLikeGroupDisabled || !isAuth} onClick={() => removeDisLike()} style={{alignItems: "right"}}>
                      <ThumbDownIcon color='error' className={styles.likeIcon}/>
                    </IconButton>
                    :
                    <IconButton disabled={isLikeGroupDisabled || !isAuth} onClick={() => dislikePost()} style={{alignItems: "right"}}>
                      <ThumbDownIcon className={styles.likeIcon}/>
                    </IconButton>
                  }
                  <p className={styles.numOfLikes}>{disLikedBy && disLikedBy.length ? disLikedBy.length : 0}</p>
                </div>
            </Stack>
          </Grid>
          <Grid container xs={6} justifyContent="flex-end">
            <ShareCustom link={`http://localhost:3000/${post_id}`}/>
            {
              //YOOOOOOOOOOOOO change this
            }
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ConfessionCard;
